if (!customElements.get('shop-the-look')) {
    class ShopTheLook extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {


            window.addEventListener('DOMContentLoaded', (event) => {
                let drawer = document.getElementById('Product-Drawer'),
                    body = document.body,
                    _this = this;
                //click outside of the element to close the drawer
                document.addEventListener('click', function (evt) {
                    if (
                        _this.classList.contains("slide-on")
                        &&  !evt.target.classList.contains('thb-hotspot-bubble')
                        &&  !evt.target.parentNode.classList.contains('thb-hotspot-bubble')
                        &&  !evt.target.classList.contains('thb-hotspot-product')
                        &&  !evt.target.classList.contains('thb-hotspot-product-title')
                        && evt.target.id!=="toggle-all-products"
                        && evt.target.parentNode.id!=="toggle-all-products"
                        &&  !evt.target.classList.contains('flickity-nav')

                    ) {
                        const slider_toggle_btn = document.getElementById('toggle-all-products');
                        const open_text = slider_toggle_btn.getAttribute('data-open');
                        //get the text from element data-open tag
                        const close_text = slider_toggle_btn.getAttribute('data-close');
                        const innerSpan = slider_toggle_btn.querySelector("span");

                        innerSpan.innerText = innerSpan.innerText.toLowerCase() === open_text.toLowerCase() ? close_text : open_text;
                        _this.classList.remove('slide-on');
                    }

                });
                document.getElementById('toggle-all-products').addEventListener('click', function (evt) {
                    const open_text = this.getAttribute('data-open');
                    //get the text from element data-open tag
                    const close_text = this.getAttribute('data-close');
                    const innerSpan = this.querySelector("span");

                    innerSpan.innerText = innerSpan.innerText.toLowerCase() === open_text.toLowerCase() ? close_text : open_text;
                    evt.preventDefault();
                    _this.classList.toggle('slide-on');
                });
                this.hotspots = this.querySelectorAll('.thb-hotspot');
                this.sliderspots = this.querySelectorAll('.thb-hotspot-slider .thb-hotspot-bubble');
                this.sliderspots.forEach((hotspot, index) => {
                    hotspot.addEventListener('click', function (evt) {
                        let productHandle = hotspot.dataset.productHandle,
                            href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;
                        href = href.replace('//', '/');
                        if (!href || !productHandle) {
                            return;
                        }
                        fetch(href, {
                            method: 'GET'
                        })
                            .then((response) => {
                                hotspot.classList.remove('loading');
                                return response.text();
                            })
                            .then(text => {
                                const sectionInnerHTML = new DOMParser()
                                    .parseFromString(text, 'text/html')
                                    .querySelector('#Product-Drawer-Content').innerHTML;

                                _this.renderQuickview(sectionInnerHTML, drawer, body, href, productHandle);

                            });
                    })
                })
                this.hotspots.forEach((hotspot, index) => {
					//add mouse over mouse out events and toggle parrent class
					hotspot.addEventListener('mouseover', function (evt) {
						evt.preventDefault();
						hotspot.parentNode.classList.add('active');

					})
					hotspot.addEventListener('mouseout', function (evt) {
						evt.preventDefault();
						hotspot.parentNode.classList.remove('active');

					})
                    hotspot.addEventListener('click', function (evt) {
                        evt.preventDefault();
                        document.querySelectorAll('.thb-hotspot').forEach((hspt) => {
                            hspt.classList.remove('on');
                        });
                        hotspot.classList.add('on');
                        let productHandle = hotspot.dataset.productHandle,
                            href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

                        // remove double `/` in case shop might have /en or language in URL
                        href = href.replace('//', '/');
                        if (!href || !productHandle) {
                            return;
                        }
                        if (hotspot.classList.contains('loading')) {
                            return;
                        }
                        hotspot.classList.add('loading');
                        fetch(href, {
                            method: 'GET'
                        })
                            .then((response) => {
                                hotspot.classList.remove('loading');
                                return response.text();
                            })
                            .then(text => {
                                const sectionInnerHTML = new DOMParser()
                                    .parseFromString(text, 'text/html')
                                    .querySelector('#Product-Drawer-Content').innerHTML;

                                _this.renderQuickview(sectionInnerHTML, drawer, body, href, productHandle);

                            });
                    });
                });
            });
        }

        renderQuickview(sectionInnerHTML, drawer, body, href, productHandle) {
            if (sectionInnerHTML) {
                drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

                setTimeout(() => {
                    if (Shopify && Shopify.PaymentButton) {
                        Shopify.PaymentButton.init();
                    }
                }, 300);
                body.classList.add('open-cc');
                drawer.classList.add('active');
                setTimeout(() => {
                    drawer.querySelector('.product-quick-images--container').classList.add('active');
                });
                drawer.querySelector('.side-panel-close').focus();
                dispatchCustomEvent('quick-view:open', {
                    productUrl: href,
                    productHandle: productHandle
                });
            }
        }
    }

    customElements.define('shop-the-look', ShopTheLook);
}
